module.exports = __webpack_amd_options__;



/*****************
 ** WEBPACK FOOTER
 ** (webpack)/buildin/amd-options.js
 ** module id = 56
 ** module chunks = 1
 **/